var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlugins = function SvgPlugins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7 4.75A2.25 2.25 0 0 0 4.75 7v2A2.25 2.25 0 0 0 7 11.25h10A2.25 2.25 0 0 0 19.25 9V7A2.25 2.25 0 0 0 17 4.75zM6.25 7A.75.75 0 0 1 7 6.25h10a.75.75 0 0 1 .75.75v2a.75.75 0 0 1-.75.75H7A.75.75 0 0 1 6.25 9zM7 19.25A2.25 2.25 0 0 1 4.75 17v-2A2.25 2.25 0 0 1 7 12.75h10A2.25 2.25 0 0 1 19.25 15v2A2.25 2.25 0 0 1 17 19.25zM6.25 17c0 .414.336.75.75.75h10a.75.75 0 0 0 .75-.75v-2a.75.75 0 0 0-.75-.75H7a.75.75 0 0 0-.75.75z",
    clipRule: "evenodd"
  })));
};
export default SvgPlugins;